export default {
  form: {
    first_name: {
      label: 'Imię',
    },
    last_name: {
      label: 'Nazwisko',
    },
    email: {
      label: 'E-mail',
    },
    phone_number: {
      label: 'Numer telefonu',
    },
    birthday: {
      label: 'Data urodzenia',
    },
    city: {
      label: 'Miasto',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    success: 'Profil zaktualizowany pomyślnie',
    error: 'Nie udało się zaktualizować profilu',
  },
};
